<template>
  <div class="agent-app-wrapper">

    <!--操作按钮-->
    <div class="custom-wrapper op-wrapper">
      <el-button
        type="danger"
        size="medium"
        @click="addAgentAppDialogVisible = true">添加代理商应用</el-button>
    </div>

    <!--过滤表单-->
    <agent-app-filter @filter="updateTableData" />

    <!--用户应用列表-->
    <div class="agent-app-list custom-wrapper" v-if="agentAppList.length > 0">
      <div
        class="agent-app"
        v-for="agentApp in agentAppList"
        :key="agentApp.uesr_app_id">
        <el-card>
          <div slot="header" class="clearfix">
            <el-tooltip placement="top">
              <div slot="content">
                代理商 ID: {{ agentApp.agentid }} <br/>
                代理商昵称: {{ agentApp.agent_detail.nickname }}
              </div>
              <span>{{ agentApp.agent_detail.agentname }}</span>
            </el-tooltip>
          </div>

          <div class="agent-app-info">
            <div class="label-info">
              <p>应用名:</p>
              <p>{{ agentApp.app_store_detail && agentApp.app_store_detail.app_name_i18n[0].name }}</p>
            </div>
            <div class="label-info">
              <p>应用分类:</p>
              <p>{{ agentApp.app_store_detail && agentApp.app_store_detail.app_category_name_i18n[0].name }}</p>
            </div>
            <div class="label-info">
              <p>开始时间:</p>
              <p>{{ agentApp.start_at | dateformat }}</p>
            </div>
            <div class="label-info">
              <p>过期时间:</p>
              <p>{{ agentApp.expire_at | dateformat }}</p>
            </div>
          </div>

          <div class="agent-app-op">
            <el-button
              type="text"
              @click="onEditClick(agentApp)">修改</el-button>
            <el-button
              type="text"
              class="danger-text"
              @click="onDeleteClick(agentApp)">删除</el-button>
          </div>
        </el-card>
      </div>

    </div>

    <div
      class="custom-wrapper"
      style="display: flex;
        justify-content: center;
        padding: 20px 0;
        color: #909399;"
      v-else>
      暂无数据
    </div>

    <!--列表分页-->
    <custom-paginate
      :count="agentAppCount"
      @page-change="updateTableData" />

    <dialog-add-agent-app
      @data-change="updateTableData"
      :visible.sync="addAgentAppDialogVisible" />

    <dialog-edit-agent-app
      @data-change="updateTableData"
      :editing-agent-app="editingAgentApp"
      :visible.sync="editAgentAppDialogVisible" />

  </div>
</template>

<script>
import CustomPaginate from '@/components/CustomPaginate'
import AgentAppFilter from './components/AgentAppFilter'
import DialogAddAgentApp from './components/DialogAddAgentApp'
import DialogEditAgentApp from './components/DialogEditAgentApp'

import { mapState, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_PAGE_SIZE, SET_LOADING, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'AgentApp',
  components: {
    CustomPaginate,
    AgentAppFilter,
    DialogAddAgentApp,
    DialogEditAgentApp
  },
  data () {
    return {
      addAgentAppDialogVisible: false,

      editAgentAppDialogVisible: false,
      editingAgentApp: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'filters'
    ]),
    ...mapState('store', [
      'agentAppList',
      'agentAppCount'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_PAGE_SIZE,
      SET_LOADING,
      SET_FILTERS
    ]),
    ...mapActions('store', [
      'getAgentApps',
      'deleteAgentApp'
    ]),

    onEditClick (agentApp) {
      this.editingAgentApp = agentApp
      this.editAgentAppDialogVisible = true
    },
    async onDeleteClick (agentApp) {
      try {
        await this.$confirm(
          '此操作将永久删除代理商应用，是否继续？', '删除代理商应用',
          { confirmButtonText: '确定', cancelButtonText: '取消' }
        )

        await this.deleteAgentApp({
          agent_app_id: agentApp.agent_app_id
        })
        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    async updateTableData () {
      this.setLoading(true)

      try {
        await this.getAgentApps({
          page: this.page,
          pageSize: this.pageSize,
          condition: this.filters
        })
      } catch (err) {
        console.log(err)

        this.$message({
          type: 'error',
          message: '获取代理商应用列表失败'
        })
      }
      this.setLoading(false)
    }
  },
  mounted () {
    this.setPage(1)
    this.setPageSize(8)
    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/base';

.agent-app-wrapper {

  .op-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .agent-app-list {
    display: flex;
    justify-content: space-start;
    align-items: center;
    flex-flow: row wrap;

    .agent-app {
      width: 23%;
      padding: 10px;

      .agent-app-info {

        .label-info {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        p {
          line-height: 1.5;
          margin: 0;
        }
      }

      .agent-app-op {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/AgentApp.vue